// extracted by mini-css-extract-plugin
export default {"spinner":"PromptButton_spinner__kSOc4"};